<template>
  <div id="supply-trend" style="height: 160px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: { show: false },
        grid: { top: 0, left: 0, right: 0, bottom: 24 },
        legend: {
          data: [
            { name: '产量（万吨）', color: '#e3e067' },
            { name: '产值（亿元）', color: '#4fe916' },
          ],
          textStyle: { fill: '#cfcfcf' },
          top: 15,
          right: 0,
        },
        xAxis: {
          name: '',
          data: [ '2019', '2020', '2021', '2022','2023'],
          axisLabel: {
            formatter: '{value}年',
            style: { fill: '#cfcfcf' },
          },
        },
        yAxis: {
          name: '',
          data: 'value',
          min: 0,
          max: 40,
          interval: 10,
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: {
            style: { stroke: '#3f3f3f' },
          },
        },
        series: [
          {
            name: '产量（万吨）',
            stack: 'a',
            data: [23.9, 28.9, 25.8, 31.1, 32.5],
            type: 'bar',
            shapeType: 'leftEchelon',
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#e3e067' },
              position: 'bottom',
            },
            gradient: {
              // color: ['#37a2da', '#67e0e3'],
              color: ['rgba(0xda,0xa2,0x37,.75)', 'rgba(0xe3,0xe0,0x67,.2)'],
            },
          },
          {
            name: '产值（亿元）',
            data: [21.7, 23.2, 24.7, 23.6, 25.4],
            type: 'line',
            lineStyle: { stroke: '#4fe916', lineWidth: 2 },
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#4fe916' },
            },
            // gradient: {
            //   color: ['#daa237', '#e3e067'],
            // },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('supply-trend')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/market-zone/supply-trend.vue